import { render } from "./ConsentForm.vue?vue&type=template&id=23c18ab2&ts=true"
import script from "./ConsentForm.vue?vue&type=script&lang=ts"
export * from "./ConsentForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Consents/ConsentForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23c18ab2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23c18ab2', __exports__)) {
    api.reload('23c18ab2', __exports__)
  }
  
  module.hot.accept("./ConsentForm.vue?vue&type=template&id=23c18ab2&ts=true", () => {
    api.rerender('23c18ab2', render)
  })

}


export default __exports__